module.exports = __webpack_public_path__ + "static/media/pink_red2.8d2fe5c7.jpg";